import { render } from "./StickyTable.vue?vue&type=template&id=59551fd4"
import script from "./StickyTable.vue?vue&type=script&lang=js"
export * from "./StickyTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__